import React, { useState } from "react";
import PropTypes from "prop-types";
import { useMutation } from "react-apollo";
import { Field, Control, Input, Label, Button } from "rbx";
import { DrugTestCategorySelect } from "../inputs";
import { GENERATE_RANDOM_DRUG_TESTS } from "../../graphql/DrugTests/DrugTests.graphql";
import { ourToast as toast } from "../../utils";

const DEFAULT_STATE = {
  EmployeeQuantity: "",
  TestCategoryRecIdRef: 0
};

const AddDrugTestBatchForm = ({ onComplete }) => {
  const [inputs, setInputs] = useState({ ...DEFAULT_STATE });
  const [generateRandomDrugTests, { loading }] = useMutation(
    GENERATE_RANDOM_DRUG_TESTS
  );

  const handleChange = e => {
    const { value } = e.target;
    setInputs({
      ...inputs,
      [e.target.name]: parseInt(value)
    });
  };

  const generateRandomTests = async () => {
    try {
      if (!inputs.EmployeeQuantity || !inputs.TestCategoryRecIdRef)
        toast.error("Form inputs required.");
      const { data } = await generateRandomDrugTests({
        variables: {
          Top: inputs.EmployeeQuantity,
          TestCategoryRecIdRef: inputs.TestCategoryRecIdRef
        }
      });
      if (!data.generateRandomDrugTests)
        toast.error("Error generating the Random Tests.");
      toast.success("Drug Tests generated successfully");
      onComplete(parseInt(data.generateRandomDrugTests));
    } catch (err) {
      toast.error("Error generating Random Tests.");
    }
  };

  return (
    <React.Fragment>
      <Field kind="group">
        <Control>
          <Label>Number of Employees to Test</Label>
          <Input
            required
            min="1"
            name="EmployeeQuantity"
            type="number"
            value={inputs.EmployeeQuantity}
            onChange={handleChange}
          />
        </Control>
        <Control>
          <DrugTestCategorySelect
            required
            icon="globe"
            label="Drug Test Category"
            name="TestCategoryRecIdRef"
            value={inputs.TestCategoryRecIdRef}
            onChange={handleChange}
          />
        </Control>
      </Field>
      <div style={{ textAlign: "center" }}>
        <Button
          color="success"
          size="medium"
          state={loading ? "loading" : ""}
          onClick={generateRandomTests}
        >
          Generate
        </Button>
      </div>
    </React.Fragment>
  );
};

AddDrugTestBatchForm.propTypes = {
  onComplete: PropTypes.func
};
export default AddDrugTestBatchForm;
